import { Alert } from "react-bootstrap";
import useUserStore from "../../stores/user-store";
import LoggedInLayout from "../../layouts/loggedin-layout";

const NotFound = () => {
    const LoggedIn = useUserStore((state) => state.loggedIn);
    
    if(LoggedIn){
        return(
            <LoggedInLayout>
                <NotFoundAlert />
            </LoggedInLayout>
        )
    }
    else{
        return(
            <div>
                <NotFoundAlert />
            </div>
        )
    }
}

const NotFoundAlert = () => {
    return(
        <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '100vh'}}>
            <Alert variant="danger">
                <Alert.Heading>The page you were looking for does not exist.</Alert.Heading>
                <p>You requested a page that does not currently exist.</p>
            </Alert>
        </div>
    )
}

export default NotFound;